import * as React from "react";
const SvgSearch20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM7.5 0a7.5 7.5 0 1 0 4.55 13.463L16 17.414 17.414 16l-3.95-3.95A7.5 7.5 0 0 0 7.5 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgSearch20Px;
